import React from "react";
import { Card, CardBody } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";

const OrderServiceInfoSection = ({ requestServiceType, requestOrderNumber }) => {

  if (requestServiceType !== "ORDER") return (<></>);

  return (
    <Card className="question d-flex mb-4">
      <CardBody>
        <div className="edit-mode">
          <div>
            <h1 className="list-item-heading float-left w-20 mb-1">
              <IntlMessages id="request.order_number" />
            </h1>
            <div
              className="list-item-heading float-right w-75 mb-1"
              dangerouslySetInnerHTML={{ __html: requestOrderNumber ?? "" }}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default OrderServiceInfoSection;
